(function() {
  var SECTION_SELECTOR = '.product-section[data-section-type="product"]';
  var META_SELECTOR = '[data-variant-grouping-values]';
  var META_TITLE_SELECTOR = '[data-variant-grouping-title]';
  var VARIANT_JSON_SELECTOR = '[data-variant-json]';
  var VARIANT_INTERACTION_SELECTOR = '.rio-options [data-option-value], .rio-options [data-value], .rio-options [data-variant-value], .rio-options [role="button"], .rio-options [role="radio"], .rio-options button, .rio-options input, .variant-input-wrap [data-value], .variant-input-wrap [data-variant-input], .variant-input-wrap input, .variant-input-wrap label';
  var REAPPLY_DELAYS = [0, 120, 300, 650];
  var STYLE_ID = 'mivelo-variant-grouping-style';
  var stateMap = new WeakMap();

  function isDebugEnabled() {
    return !!window.MIVELO_VARIANT_GROUPING_DEBUG;
  }

  function debugLog(message, payload) {
    if (!isDebugEnabled()) {
      return;
    }

    if (payload !== undefined) {
      console.log('[VariantGrouping]', message, payload);
      return;
    }

    console.log('[VariantGrouping]', message);
  }

  function sectionRef(section) {
    if (!section) {
      return '';
    }

    return section.getAttribute('data-product-handle') || section.getAttribute('data-product-id') || 'unknown-product';
  }

  function containerRef(container) {
    if (!container) {
      return '';
    }

    var optionName = container.getAttribute('data-option');
    var typeName = container.getAttribute('data-type');
    var className = (container.className || '').toString().trim().replace(/\s+/g, '.');

    return {
      option: optionName || null,
      type: typeName || null,
      className: className || null
    };
  }

  function normalizeValue(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function normalizeHandle(value) {
    return normalizeValue(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function parseJsonNode(node) {
    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    if (element.offsetParent === null && style.position !== 'fixed') {
      return false;
    }

    return true;
  }

   function ensureStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.sh-mivelo-variant-target {',
      '  display: flex;',
      '  flex-wrap: wrap;',
      '  column-gap: 0;',
      '}',
      '.sh-mivelo-variant-group-title {',
      '  width: 100%;',
      '  flex-basis: 100%;',
      '  display: block;',
      '  margin: 10px 0 6px;',
      '  text-align: left;',
      '}',
      '.sh-mivelo-variant-group-break {',
      '  width: 100%;',
      '  flex-basis: 100%;',
      '  height: 0;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function getGroupingConfig(section) {
    var metafieldData = parseJsonNode(section.querySelector(META_SELECTOR));
    if (metafieldData === null || metafieldData === undefined || metafieldData === '') {
      return null;
    }

    var groupedValues = normalizeMetafieldValues(metafieldData);
    var groupingTitle = parseGroupingTitle(section);
    if (!groupedValues.length) {
      return null;
    }

    var variants = parseJsonNode(section.querySelector(VARIANT_JSON_SELECTOR));
    if (!Array.isArray(variants) || !variants.length) {
      return null;
    }

    var optionMaps = [new Map(), new Map(), new Map()];
    variants.forEach(function(variant) {
      [variant.option1, variant.option2, variant.option3].forEach(function(optionValue, index) {
        var normalized = normalizeValue(optionValue);
        if (!normalized || optionMaps[index].has(normalized)) {
          return;
        }

        optionMaps[index].set(normalized, optionValue);
      });
    });

    var scores = optionMaps.map(function(map) {
      var score = 0;
      groupedValues.forEach(function(value) {
        if (map.has(value)) {
          score += 1;
        }
      });
      return score;
    });

    var bestScore = Math.max.apply(Math, scores);
    if (bestScore <= 0) {
      return null;
    }

    var bestIndexes = [];
    scores.forEach(function(score, index) {
      if (score === bestScore) {
        bestIndexes.push(index);
      }
    });

    if (bestIndexes.length !== 1) {
      return null;
    }

    var optionIndex = bestIndexes[0];
    var groupedSet = new Set();
    groupedValues.forEach(function(value) {
      if (optionMaps[optionIndex].has(value)) {
        groupedSet.add(value);
      }
    });

    if (!groupedSet.size) {
      return null;
    }

    var nativeWrap = section.querySelector('.variant-input-wrap[data-index="option' + (optionIndex + 1) + '"]');
    var optionName = nativeWrap ? nativeWrap.getAttribute('name') || '' : '';
    var optionHandle = nativeWrap ? nativeWrap.getAttribute('data-handle') || '' : '';
    if (!optionHandle && optionName) {
      optionHandle = normalizeHandle(optionName);
    }

    var config = {
      optionIndex: optionIndex,
      optionName: normalizeValue(optionName),
      optionHandle: normalizeHandle(optionHandle),
      groupTitle: groupingTitle,
      groupedValues: groupedSet,
      optionValues: new Set(optionMaps[optionIndex].keys())
    };

    debugLog('Detected variant option for grouping', {
      section: sectionRef(section),
      optionIndex: config.optionIndex,
      optionName: config.optionName || null,
      optionHandle: config.optionHandle || null,
      groupTitle: config.groupTitle || null,
      metafieldMatchedValues: Array.from(config.groupedValues),
      optionAllValues: Array.from(config.optionValues)
    });

    return config;
  }

  function parseGroupingTitle(section) {
    var rawTitle = parseJsonNode(section.querySelector(META_TITLE_SELECTOR));
    if (typeof rawTitle !== 'string') {
      return '';
    }

    return rawTitle.trim();
  }

  function normalizeMetafieldValues(rawValue) {
    var values = [];

    if (Array.isArray(rawValue)) {
      values = rawValue.slice();
    } else if (typeof rawValue === 'string') {
      values = splitGroupingString(rawValue);
    } else if (rawValue !== null && rawValue !== undefined) {
      values = [String(rawValue)];
    }

    return Array.from(new Set(
      values
        .map(normalizeValue)
        .filter(Boolean)
    ));
  }

  function splitGroupingString(input) {
    if (!input || !input.trim()) {
      return [];
    }

    return input
      .split(/\s*[•,;|/]\s*/g)
      .map(function(part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function getClosestDirectChild(node, container) {
    var current = node;
    while (current && current.parentElement !== container) {
      current = current.parentElement;
    }

    if (!current || current === container) {
      return null;
    }

    return current;
  }

  function extractChoiceValue(node) {
    var fromData =
      node.getAttribute('data-option-value') ||
      node.getAttribute('data-value') ||
      node.getAttribute('data-variant-value') ||
      node.getAttribute('aria-label') ||
      node.getAttribute('title');

    if (fromData) {
      return fromData;
    }

    return node.textContent || '';
  }

  function collectChoices(container, optionValues) {
    var choices = [];
    var seen = new Set();
    var directItems = Array.prototype.slice.call(container.children).filter(function(child) {
      if (!isVisible(child)) {
        return false;
      }

      if (child.matches('[data-option-value], [data-value], [data-variant-value], [role="button"], [role="radio"]')) {
        return true;
      }

      return !!child.querySelector('[data-option-value], [data-value], [data-variant-value], [role="button"], [role="radio"]');
    });

    directItems.forEach(function(itemNode) {
      var valueNode = itemNode.matches('[data-option-value], [data-value], [data-variant-value], [role="button"], [role="radio"]')
        ? itemNode
        : itemNode.querySelector('[data-option-value], [data-value], [data-variant-value], [role="button"], [role="radio"]');
      if (!valueNode) {
        return;
      }

      var value = normalizeValue(extractChoiceValue(valueNode));
      if (!value || !optionValues.has(value) || seen.has(itemNode)) {
        return;
      }

      seen.add(itemNode);
      choices.push({
        node: itemNode,
        value: value
      });
    });

    // Fallback for non-standard variants where choices are nested differently.
    // Some PDPs (button type) have one direct child wrapping multiple options.
    if (choices.length < 2) {
      choices = [];
      seen = new Set();
      var selectors = '[data-option-value], [data-value], [data-variant-value], [role="button"], [role="radio"]';
      container.querySelectorAll(selectors).forEach(function(node) {
        if (!isVisible(node)) {
          return;
        }

        var fallbackValue = normalizeValue(extractChoiceValue(node));
        if (!fallbackValue || !optionValues.has(fallbackValue)) {
          return;
        }

        var choiceItem = getChoiceItemNode(node, container);
        if (!choiceItem || !isVisible(choiceItem) || seen.has(choiceItem)) {
          return;
        }

        seen.add(choiceItem);
        choices.push({
          node: choiceItem,
          value: fallbackValue
        });
      });
    }

    return choices;
  }

  function resolveCandidateContainers(section, config) {
    var appScopes = getAppOptionScopes(section);
    var nativeScopes = getNativeOptionScopes(section);
    var optionScopes = appScopes.concat(nativeScopes);
    if (!optionScopes.length) {
      return [];
    }

    var directMatches = optionScopes.filter(function(node) {
      var optionName = getOptionNameForScope(node);
      var optionHandle = getOptionHandleForScope(node, optionName);

      if (config.optionName && optionName === config.optionName) {
        return true;
      }

      if (config.optionHandle && optionHandle === config.optionHandle) {
        return true;
      }

      return false;
    });

    if (directMatches.length) {
      return directMatches;
    }

    // Fallback: labels can differ by locale/source, still attempt best-match scoring later.
    return optionScopes;
  }

  function getAppOptionScopes(section) {
    var rioOptions = Array.prototype.slice.call(section.querySelectorAll('.rio-options')).filter(isVisible);
    if (!rioOptions.length) {
      return [];
    }

    var optionScopes = [];
    rioOptions.forEach(function(rioContainer) {
      optionScopes = optionScopes.concat(getOptionScopesFromRioContainer(rioContainer));
    });
    return optionScopes;
  }

  function getOptionScopesFromRioContainer(rioContainer) {
    var scopes = Array.prototype.slice.call(rioContainer.querySelectorAll('[data-option]')).filter(function(node) {
      return isVisible(node) && node.closest('.rio-options') === rioContainer;
    });

    if (scopes.length) {
      return scopes;
    }

    return [rioContainer];
  }

  function getNativeOptionScopes(section) {
    return Array.prototype.slice.call(section.querySelectorAll('.variant-input-wrap[data-index]')).filter(isVisible);
  }

  function getOptionNameForScope(scope) {
    if (!scope) {
      return '';
    }

    if (scope.hasAttribute('data-option')) {
      return normalizeValue(scope.getAttribute('data-option'));
    }

    if (scope.hasAttribute('name')) {
      return normalizeValue(scope.getAttribute('name'));
    }

    if (scope.hasAttribute('data-handle')) {
      return normalizeValue(scope.getAttribute('data-handle'));
    }

    return '';
  }

  function getOptionHandleForScope(scope, optionName) {
    if (!scope) {
      return '';
    }

    if (scope.hasAttribute('data-handle')) {
      return normalizeHandle(scope.getAttribute('data-handle'));
    }

    return normalizeHandle(optionName || getOptionNameForScope(scope));
  }

  function getChoiceItemNode(node, container) {
    var current = node;
    while (current && current !== container) {
      var parent = current.parentElement;
      if (!parent) {
        break;
      }

      if (parent === container) {
        return current;
      }

      var similarSiblings = Array.prototype.slice.call(parent.children).filter(function(child) {
        return child.querySelector('[data-option-value], [data-value], [data-variant-value], [role="radio"], [role="button"], button');
      });

      if (similarSiblings.length >= 2) {
        return current;
      }

      current = parent;
    }

    return getClosestDirectChild(node, container);
  }

  function findTargets(section, config) {
    var candidates = resolveCandidateContainers(section, config);
    var targets = [];

    candidates.forEach(function(container) {
      var choices = collectChoices(container, config.optionValues);
      if (choices.length < 2) {
        return;
      }

      var matchedCount = choices.filter(function(choice) {
        return config.groupedValues.has(choice.value);
      }).length;

      if (matchedCount === 0) {
        return;
      }

      targets.push({
        container: container,
        choices: choices
      });
    });

    return targets.filter(function(target) {
      return !targets.some(function(other) {
        if (target === other) {
          return false;
        }

        return target.container.contains(other.container);
      });
    });
  }

  function getBestTargets(targets, config) {
    if (!targets.length) {
      return [];
    }

    var scored = targets.map(function(target) {
      var matchedCount = target.choices.filter(function(choice) {
        return config.groupedValues.has(choice.value);
      }).length;

      return {
        target: target,
        matchedCount: matchedCount,
        totalCount: target.choices.length
      };
    });

    var maxMatched = Math.max.apply(Math, scored.map(function(item) {
      return item.matchedCount;
    }));

    var top = scored.filter(function(item) {
      return item.matchedCount === maxMatched;
    });

    if (top.length === 1) {
      return [top[0].target];
    }

    // If tie, prefer the one with smallest choice set (usually the exact option container).
    top.sort(function(a, b) {
      return a.totalCount - b.totalCount;
    });

    return [top[0].target];
  }

  function applyGroupingToTarget(target, config) {
    var container = target.container;
    container.classList.add('sh-mivelo-variant-target');
    resetContainerGroupingState(container);

    target.choices = collectChoices(container, config.optionValues);
    var grouped = [];
    var others = [];

    target.choices.forEach(function(choice) {
      if (config.groupedValues.has(choice.value)) {
        grouped.push(choice.node);
      } else {
        others.push(choice.node);
      }
    });

    if (!grouped.length) {
      debugLog('Skipping target: grouped/remaining split not possible', {
        container: containerRef(container),
        groupedCount: grouped.length,
        remainingCount: others.length
      });
      return false;
    }

    var signature = 'option-' + config.optionIndex + '-' + Array.from(config.groupedValues).sort().join('|');
    if (!others.length) {
      applyGroupedOnly(grouped);
      if (config.groupTitle) {
        appendGroupTitle(container, config.groupTitle, 1, 'grouped');
      }
    } else {
      applyOrderedGroups(grouped, others);
      if (config.groupTitle) {
        appendGroupTitle(container, config.groupTitle, 3, 'grouped');
      }
      appendGroupBreak(container, 2);
    }

    container.dataset.miveloVariantGroupSignature = signature;

    debugLog('Transformed app container into grouped wrappers', {
      container: containerRef(container),
      groupedValues: grouped.map(function(node) {
        return normalizeValue(extractChoiceValue(node));
      }),
      remainingValues: others.map(function(node) {
        return normalizeValue(extractChoiceValue(node));
      })
    });

    return true;
  }

  function resetContainerGroupingState(container) {
    var titles = container.querySelectorAll('[data-mivelo-variant-title]');
    titles.forEach(function(titleNode) {
      titleNode.parentNode.removeChild(titleNode);
    });

    var breaks = container.querySelectorAll('[data-mivelo-variant-break]');
    breaks.forEach(function(breakNode) {
      breakNode.parentNode.removeChild(breakNode);
    });

    var groupedNodes = container.querySelectorAll('[data-mivelo-choice-group]');
    groupedNodes.forEach(function(node) {
      node.removeAttribute('data-mivelo-choice-group');
      node.style.removeProperty('order');
    });
  }

  function applyOrderedGroups(groupedNodes, remainingNodes) {
    groupedNodes.forEach(function(node) {
      node.setAttribute('data-mivelo-choice-group', 'grouped');
      node.style.order = '4';
    });

    remainingNodes.forEach(function(node) {
      node.setAttribute('data-mivelo-choice-group', 'remaining');
      node.style.order = '1';
    });
  }

  function applyGroupedOnly(groupedNodes) {
    groupedNodes.forEach(function(node) {
      node.setAttribute('data-mivelo-choice-group', 'grouped');
      node.style.order = '2';
    });
  }

  function appendGroupTitle(container, text, order, groupName) {
    var titleNode = document.createElement('div');
    titleNode.classList.add('rio-product-option-title', 'sh-mivelo-variant-group-title');
    titleNode.setAttribute('data-mivelo-variant-title', groupName);
    titleNode.style.order = String(order);
    titleNode.textContent = text;
    container.appendChild(titleNode);
  }

  function appendGroupBreak(container, order) {
    var breakNode = document.createElement('div');
    breakNode.className = 'sh-mivelo-variant-group-break';
    breakNode.setAttribute('data-mivelo-variant-break', 'true');
    breakNode.style.order = String(order);
    container.appendChild(breakNode);
  }

  function applyGrouping(section) {
    var state = stateMap.get(section);
    if (!state || state.applying) {
      return false;
    }

    if (!section.querySelector('.rio-options') && !section.querySelector('.variant-input-wrap[data-index]')) {
      debugLog('Waiting for variant DOM to render', {
        section: sectionRef(section)
      });
      return false;
    }

    var config = getGroupingConfig(section);
    if (!config) {
      debugLog('Skipping: no valid grouping config', {
        section: sectionRef(section)
      });
      // Terminal state: no metafield/no valid mapping, no retries needed.
      return true;
    }

    ensureStyles();

    var targets = findTargets(section, config);
    if (!targets.length) {
      debugLog('Skipping: no matching app DOM target found', {
        section: sectionRef(section),
        optionName: config.optionName || null
      });
      return false;
    }

    targets = getBestTargets(targets, config);

    state.applying = true;
    var applied = false;
    try {
      targets.forEach(function(target) {
        if (applyGroupingToTarget(target, config)) {
          applied = true;
        }
      });
    } finally {
      state.applying = false;
    }

    return applied;
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    var state = stateMap.get(section);
    if (state) {
      scheduleSectionApply(section, 0);
      return;
    }

    state = {
      applying: false,
      applyTimer: null,
      reapplyTimers: [],
      onClick: null,
      onChange: null,
      onVariantChange: null
    };
    stateMap.set(section, state);

    bindSectionEvents(section, state);
    scheduleSectionApply(section, 0);
  }

  function bindSectionEvents(section, state) {
    state.onClick = function(evt) {
      if (!evt || !evt.target || !evt.target.closest(VARIANT_INTERACTION_SELECTOR)) {
        return;
      }

      scheduleInteractionReapply(section);
    };

    state.onChange = function(evt) {
      if (!evt || !evt.target || !evt.target.closest('.rio-options, .variant-input-wrap')) {
        return;
      }

      scheduleInteractionReapply(section);
    };

    state.onVariantChange = function() {
      scheduleInteractionReapply(section);
    };

    section.addEventListener('click', state.onClick, true);
    section.addEventListener('change', state.onChange, true);
    section.addEventListener('variantChange', state.onVariantChange);
  }

  function scheduleSectionApply(section, attempt) {
    var state = stateMap.get(section);
    if (!state) {
      return;
    }

    if (state.applyTimer) {
      window.clearTimeout(state.applyTimer);
    }

    if (applyGrouping(section)) {
      return;
    }

    if (attempt >= 35) {
      debugLog('Stopped retrying grouping (max attempts reached)', {
        section: sectionRef(section)
      });
      return;
    }

    state.applyTimer = window.setTimeout(function() {
      scheduleSectionApply(section, attempt + 1);
    }, 200);
  }

  function scheduleInteractionReapply(section) {
    var state = stateMap.get(section);
    if (!state) {
      return;
    }

    if (state.reapplyTimers && state.reapplyTimers.length) {
      state.reapplyTimers.forEach(function(timerId) {
        window.clearTimeout(timerId);
      });
    }
    state.reapplyTimers = [];

    REAPPLY_DELAYS.forEach(function(delay) {
      var timerId = window.setTimeout(function() {
        scheduleSectionApply(section, 0);
      }, delay);
      state.reapplyTimers.push(timerId);
    });
  }

  function destroySection(section) {
    var state = stateMap.get(section);
    if (!state) {
      return;
    }

    if (state.applyTimer) {
      window.clearTimeout(state.applyTimer);
    }

    if (state.reapplyTimers && state.reapplyTimers.length) {
      state.reapplyTimers.forEach(function(timerId) {
        window.clearTimeout(timerId);
      });
    }

    if (state.onClick) {
      section.removeEventListener('click', state.onClick, true);
    }
    if (state.onChange) {
      section.removeEventListener('change', state.onChange, true);
    }
    if (state.onVariantChange) {
      section.removeEventListener('variantChange', state.onVariantChange);
    }

    stateMap.delete(section);
  }

  function initAllSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function(section) {
      initSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllSections);
  document.addEventListener('shopify:section:load', initAllSections);
  document.addEventListener('shopify:section:reorder', initAllSections);
  document.addEventListener('shopify:section:unload', function(evt) {
    if (!evt || !evt.target) {
      return;
    }

    if (evt.target.matches && evt.target.matches(SECTION_SELECTOR)) {
      destroySection(evt.target);
    }
  });
})();
